import * as React from 'react';
import { useDispatch } from 'react-redux';

import { TTypedThunkDispatch } from '../../types/thunk';
import { trackingActionClickDevelopersFlats } from '../../actions/analytics';
import { Link } from '@cian/ui-kit';

interface IRoomCountsProps {
  fromDeveloperPropsLink?: string;
  fromDeveloperPropsCount: number;
  fromDeveloperCountsDisplay?: string;
}

export function RoomCounts(props: IRoomCountsProps) {
  const { fromDeveloperPropsLink, fromDeveloperPropsCount, fromDeveloperCountsDisplay } = props;

  const dispatch = useDispatch<TTypedThunkDispatch>();

  const trackingClickDevelopersFlats = React.useCallback(() => {
    dispatch(trackingActionClickDevelopersFlats('all-variants'));
  }, [dispatch]);

  if (!fromDeveloperPropsLink || fromDeveloperPropsCount === 0) {
    return null;
  }

  return (
    <Link
      fontSize="M"
      fontWeight="bold"
      onClick={trackingClickDevelopersFlats}
      href={fromDeveloperPropsLink}
      target="_blank"
    >
      {fromDeveloperCountsDisplay}
    </Link>
  );
}
